import * as THREE from 'three';

import Experience from '../Experience.js';

export default class Project {
  constructor(_options) {
    this.experience = new Experience();
    this.config = this.experience.config;
    this.resources = this.experience.resources;
    this.sizes = this.experience.sizes;
    this.time = this.experience.time;
    this.scene = this.experience.scene;
    this.debug = this.experience.debug;

    if (this.debug) {
      this.debugFolder = this.debug.addFolder({
        title: 'raycaster'
      });
    }

    this.width = 479;
    this.height = 800;
    this.ratio = this.width / this.height;
    this.count = this.width * this.height;
    this.group = new THREE.Group();
    this.scene.add(this.group);

    this.setRaycasterGeometry();
  }

  setRaycasterGeometry() {
    this.smallBox = new THREE.BoxBufferGeometry(0.258, 0.258, 0.16);
    this.largeBox = new THREE.BoxBufferGeometry(0.6, 0.258, 0.16);
    this.bigBox = new THREE.BoxBufferGeometry(7, 5, 5);
    this.skillGeo = new THREE.BoxBufferGeometry(3.96, 3.04, 7.25);
    this.projectGeo = new THREE.BoxBufferGeometry(5.74, 3.91, 5.22);
    this.material = new THREE.MeshStandardMaterial({
      wireframe: true,
      visible: false
    });

    this.twiterBox = new THREE.Mesh(this.smallBox, this.material);
    this.gmailBox = new THREE.Mesh(this.smallBox, this.material);
    this.linkedinBox = new THREE.Mesh(this.smallBox, this.material);
    this.gitBox = new THREE.Mesh(this.smallBox, this.material);
    this.resumeBox = new THREE.Mesh(this.largeBox, this.material);

    this.contactBox = new THREE.Mesh(this.bigBox, this.material);
    this.skillsBox = new THREE.Mesh(this.skillGeo, this.material);
    this.projectsBox = new THREE.Mesh(this.projectGeo, this.material);

    this.twiterBox.position.set(2.63, 3.49, -10.17);
    this.twiterBox.layers.set(4);
    this.twiterBox.name = 'twitter';
    this.gmailBox.position.set(2.96, 3.49, -10.17);
    this.gmailBox.layers.set(4);
    this.gmailBox.name = 'gmail';
    this.linkedinBox.position.set(3.3, 3.49, -10.17);
    this.linkedinBox.layers.set(4);
    this.linkedinBox.name = 'linkedin';
    this.gitBox.position.set(3.3, 3.13, -10.17);
    this.gitBox.layers.set(4);
    this.gitBox.name = 'git';

    this.resumeBox.position.set(2.81, 3.13, -10.17);
    this.resumeBox.layers.set(4);
    this.resumeBox.name = 'resume';

    this.contactBox.position.set(3.04, 1.74, -8.22);
    this.contactBox.layers.set(5);
    this.contactBox.name = 'contact';

    this.skillsBox.position.set(-0.95, 1.01, -0.66);
    this.skillsBox.layers.set(5);
    this.skillsBox.name = 'skills';

    this.projectsBox.position.set(11.02, 1.54, -6.96);
    this.projectsBox.layers.set(5);
    this.projectsBox.name = 'projects';

    this.group.add(
      this.twiterBox,
      this.gmailBox,
      this.linkedinBox,
      this.gitBox,
      this.contactBox,
      this.skillsBox,
      this.projectsBox,
      this.resumeBox
    );

    if (this.debug) {
      this.debugFolder.addInput(this.resumeBox.position, 'x', {
        label: 'x',
        min: -20,
        max: 40,
        step: 0.01
      });
      this.debugFolder.addInput(this.resumeBox.position, 'y', {
        label: 'y',
        min: -20,
        max: 40,
        step: 0.01
      });
      this.debugFolder.addInput(this.resumeBox.position, 'z', {
        label: 'z',
        min: -20,
        max: 40,
        step: 0.01
      });
      this.debugFolder.addInput(this.resumeBox.scale, 'x', {
        label: 'x',
        min: -20,
        max: 40,
        step: 0.01
      });
      this.debugFolder.addInput(this.resumeBox.scale, 'y', {
        label: 'y',
        min: -20,
        max: 40,
        step: 0.01
      });
      this.debugFolder.addInput(this.resumeBox.scale, 'z', {
        label: 'z',
        min: -20,
        max: 40,
        step: 0.01
      });
      this.debugFolder.addInput(this.resumeBox.rotation, 'x', {
        label: 'x',
        min: -20,
        max: 40,
        step: 0.01
      });
      this.debugFolder.addInput(this.resumeBox.rotation, 'y', {
        label: 'y',
        min: -20,
        max: 40,
        step: 0.01
      });
      this.debugFolder.addInput(this.resumeBox.rotation, 'z', {
        label: 'z',
        min: -20,
        max: 40,
        step: 0.01
      });
    }
  }

  update() {}
}
